const services = [
  {
    name: "Mowing",
    description: "We mow any lawn no matter how big or small.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/lawn-mower.jpg",
    time: 1500,
  },
  {
    name: "Leaf Blowing",
    description: "Got those pesky leaves? We got it",
    imageURL: process.env.PUBLIC_URL + "assets/Services/leaf-blower.jpg",
    time: 1500,
  },
  {
    name: "Trimming and Edging",
    description: "Edging every lawn with love and care.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/lawn-edging.jpg",
    time: 1500,
  },
  {
    name: "Weed Control",
    description: ".",
    imageURL: process.env.PUBLIC_URL + "assets/Services/weed-spraying.jpg",
    time: 1500,
  },
  {
    name: "Mulching",
    description: "Edging every lawn with love and care.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/mulching.jpg",
    time: 1500,
  },
  {
    name: "Leaf Cleanup and Removal",
    description: ".",
    imageURL: process.env.PUBLIC_URL + "assets/Services/leaf-cleanup.jpeg",
    time: 1500,
  },
  {
    name: "Yard Cleanup",
    description: "Edging every lawn with love and care.",
    imageURL: process.env.PUBLIC_URL + "assets/Services/pressure-washing.jpg",
    time: 1500,
  },
];
export default services;
